import { Modal } from 'bootstrap';
export function initContactForm() {
  if(document.querySelectorAll('.kn_contact-form-block form').length > 0) {
    const modalElement = document.querySelector('#contactFormFeedbackModal');
    if(!modalElement) return;
    const formFeedbackModal = new Modal(modalElement, {});
    document.addEventListener('wpcf7submit', function(event) {
      // Check if the submitted form is a contact form
      const submittedForm = event.target;
      if (!submittedForm.closest('.kn_contact-form-block')) {
        return; // Exit if not a contact form
      }

      const { status, message } = event.detail.apiResponse;
      const feedbackContent = document.querySelector('#contactFormFeedbackContent');
      console.log(status === 'validation_failed' ? "Oops" : "Success", message);
      feedbackContent.innerHTML = `<div class="${status === 'validation_failed' ? 'text-danger' : 'text-success'}">${message}</div>`;
      formFeedbackModal.show();
    }, false);
  }
}
